import { render, staticRenderFns } from "./min-editor.vue?vue&type=template&id=9f972014&scoped=true&"
import script from "./min-editor.vue?vue&type=script&lang=js&"
export * from "./min-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f972014",
  null
  
)

export default component.exports